module.exports = __webpack_public_path__ + "static/media/S2P1_genetic-counseling.571a1c2c.mp3";